import { render, staticRenderFns } from "./AdminManageSpecialist.vue?vue&type=template&id=14cd3d54"
import script from "./AdminManageSpecialist.vue?vue&type=script&lang=js"
export * from "./AdminManageSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports